<template>
  <div id="maincut" :class="{'loaded': loaded}" v-images-loaded="slideImageLoaded">
    <ul id="maincutSlide" class="maincut_slide">
      <li v-if="film.video_identifier" class="trailer"><iframe :key="'youtube_' + film.film_identifier" width="623" height="351" :src="'https://www.youtube.com/embed/' + film.video_identifier" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe></li>
      <li v-for="i in film.image_num" :key="'cover-' + i"><img :src="'/img/lineup/cut/' + film.film_identifier + '_' + i + '.jpg'" /></li>
    </ul>
    <div id="customThumb" class="custom-thumb">
      <a v-if="film.video_identifier" :data-slide-index="0" class="trailer" :style="'background-image: url(/img/lineup/cut/' + film.film_identifier + '_1.jpg);'"></a>
      <a v-for="i in film.image_num" :key="'thumb-' + i" :data-slide-index="[film.video_identifier ? i : i - 1]" :style="'background-image: url(/img/lineup/cut/' + film.film_identifier + '_' + i + '.jpg);'"></a>
    </div>
  </div>
</template>

<style scoped>
  a {
    cursor: pointer;
  }
  a.disabled {
    cursor: default;
  }
  #maincut {
    opacity: 0;
  }
  #maincut.loaded {
    opacity: 1;
  }
</style>
<script>
import imagesLoaded from 'vue-images-loaded'
export default {
  name: 'slider',
  props: ['film', 'loaded'],
  directives: {
    imagesLoaded
  },
  methods: {
    slideImageLoaded () {
  　　this.$emit('slideImageLoaded');
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Slider.vue